// Helper functions for base64url encoding/decoding
// Helper functions for base64url encoding/decoding
// export function base64UrlDecode(base64Url) {
//   try {
//     // Add padding if necessary
//     const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
//     const padding = "==".slice(0, (4 - (base64.length % 4)) % 4);
//     const paddedBase64 = base64 + padding;

//     // For debugging
//     console.log(`Decoding: ${base64Url} -> ${paddedBase64}`);

//     // Convert base64 to binary string
//     const binary = atob(paddedBase64);

//     // Convert binary string to ArrayBuffer
//     const buffer = new Uint8Array(binary.length);
//     for (let i = 0; i < binary.length; i++) {
//       buffer[i] = binary.charCodeAt(i);
//     }

//     return buffer.buffer;
//   } catch (error) {
//     console.error("Error decoding base64url:", error);
//     throw error;
//   }
// }

// export function arrayBufferToBase64Url(buffer) {
//   const binary = String.fromCharCode(...new Uint8Array(buffer));
//   const base64 = btoa(binary);
//   return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
// }

export function base64UrlDecode(thing, name) {
  if (typeof thing === "string") {
    // base64url to base64
    thing = thing.replace(/-/g, "+").replace(/_/g, "/");

    // base64 to Uint8Array
    const str = window.atob(thing);
    const bytes = new Uint8Array(str.length);
    for (let i = 0; i < str.length; i++) {
      bytes[i] = str.charCodeAt(i);
    }
    thing = bytes;
  }

  // Array to Uint8Array
  if (Array.isArray(thing)) {
    thing = new Uint8Array(thing);
  }

  // Uint8Array to ArrayBuffer
  if (thing instanceof Uint8Array) {
    thing = thing.buffer;
  }

  // error if none of the above worked
  if (!(thing instanceof ArrayBuffer)) {
    throw new TypeError("could not coerce '" + name + "' to ArrayBuffer");
  }

  return thing;
}

export function arrayBufferToBase64Url(thing) {
  thing = coerceToBase64(thing);
  // base64 to base64url
  // NOTE: "=" at the end of challenge is optional, strip it off here
  thing = thing.replace(/\+/g, "-").replace(/\//g, "_").replace(/=*$/g, "");
  return thing;
}

export function coerceToBase64(thing) {
  // Array or ArrayBuffer to Uint8Array
  if (Array.isArray(thing)) {
    thing = Uint8Array.from(thing);
  }

  if (thing instanceof ArrayBuffer) {
    thing = new Uint8Array(thing);
  }

  // Uint8Array to base64
  if (thing instanceof Uint8Array) {
    let str = "";
    const len = thing.byteLength;

    for (let i = 0; i < len; i++) {
      str += String.fromCharCode(thing[i]);
    }
    thing = window.btoa(str);
  }

  if (typeof thing !== "string") {
    throw new Error("could not coerce to string");
  }

  return thing;
}
